<p class="font-bold line-height-2" i18n>Let's configure the RAM instance</p>
<div class="mx-6">
  <rs-error-message *ngIf="errorFound" class="mb-3" [message]="errorMessage" />

  <table style="width: auto">
    <tr>
      <th></th>
      <th style="width: 375px"></th>
      <th></th>
    </tr>
    <tr style="vertical-align: top">
      <td style="width: 20rem">
        <div style="white-space: nowrap">
          <span class="font-bold mr-1" i18n>TAR List</span>
          <span class="mr-2" i18n>(Toolkit Application Reference)</span>
        </div>
      </td>
      <td colspan="2">
        <p-table
          [value]="profileValues.ramConfiguration.tarList.tars"
          [(selection)]="profileValues.ramConfiguration.tarList.selectedTars"
          [resizableColumns]="true"
          dataKey="tarId"
          styleClass="p-datatable-striped p-datatable-gridlines"
          showGridlines="true"
          stripedRows="true"
        >
          <ng-template pTemplate="caption">
            <div class="flex align-items-center gap-2">
              <p-button i18n-label label="Add TAR" icon="pi pi-plus-circle" size="small" [outlined]="true" (onClick)="addTar()"></p-button>
              <p-button
                i18n-label
                label="Delete TAR(s)"
                icon="pi pi-trash"
                size="small"
                severity="danger"
                [outlined]="true"
                (onClick)="deleteTar()"
                [disabled]="
                  !profileValues.ramConfiguration.tarList.selectedTars || !profileValues.ramConfiguration.tarList.selectedTars.length
                "
              ></p-button>
            </div>
          </ng-template>
          <ng-template pTemplate="colgroup">
            <colgroup>
              <col style="width: 3rem" />
              <col style="width: 4rem" />
              <col />
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
              </th>
              <th>#</th>
              <th i18n>TAR Value</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-tar let-rowIndex="rowIndex">
            <tr>
              <td class="text-center">
                <p-tableCheckbox [value]="tar"></p-tableCheckbox>
              </td>
              <td class="text-center">{{ rowIndex + 1 }}</td>
              <td>
                <input
                  pInputText
                  rsHexOnlyInput
                  class="maximize-inputs console-text"
                  [maxlength]="6"
                  [(ngModel)]="tar.tarValue"
                  (input)="handleFormEvents()"
                />
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="3" i18n>No TAR Values defined.</td>
            </tr>
          </ng-template>
        </p-table>
      </td>
    </tr>
    <tr>
      <td colspan="3"><div class="mb-3"></div></td>
    </tr>
    <tr>
      <td>
        <div style="white-space: nowrap">
          <span class="font-bold mr-1" i18n>MSL</span>
          <span i18n>(Minimum Security Level)</span>
        </div>
      </td>
      <td>
        <input
          pInputText
          rsHexOnlyInput
          class="maximize-inputs console-text"
          [maxlength]="2"
          [(ngModel)]="profileValues.ramConfiguration.mslValue"
          (input)="mslInputEventHandler()"
        />
      </td>
      <td></td>
    </tr>
    <tr>
      <td></td>
      <td colspan="2">
        <div class="mt-2 mb-3" i18n>(e.g., '0E' - Cyrptographic Checksum; Ciphering; Counter available)</div>
      </td>
    </tr>
    <tr>
      <td colspan="3">
        <div class="pl-6 pr-6">
          <div class="mt-2 mb-3 font-italic" i18n>
            NOTE: Either manually enter MSL value directly above, or use the options below to automatically generate the MSL.
          </div>
          <div class="p-3" style="background: var(--rs-gray-100)">
            <table cellspacing="0" cellpadding="0">
              <tr>
                <td style="width: 30%" class="font-bold" i18n>Integrity Check Options</td>
                <td style="width: 30%" class="font-bold" i18n>Chipering Options</td>
                <td style="width: 40%" class="font-bold" i18n>Counter Options</td>
              </tr>
              <tr>
                <td colspan="3"><div class="mb-2"></div></td>
              </tr>
              <tr style="vertical-align: top">
                <td>
                  <table>
                    <tr style="vertical-align: top">
                      <td style="width: 2rem">
                        <p-radioButton
                          (onClick)="mslRadioEventHandler()"
                          name="ramConfiguration.integrityCheckOption"
                          inputId="ramConfiguration.integrityCheckOption#1"
                          value="1"
                          [(ngModel)]="profileValues.ramConfiguration.integrityCheckOption"
                        ></p-radioButton>
                      </td>
                      <td>
                        <label class="label-clickable" for="ramConfiguration.integrityCheckOption#1" i18n>No RC, CC, or DS</label>
                      </td>
                    </tr>
                    <tr style="vertical-align: top">
                      <td style="width: 2rem">
                        <p-radioButton
                          (onClick)="mslRadioEventHandler()"
                          name="ramConfiguration.integrityCheckOption"
                          inputId="ramConfiguration.integrityCheckOption#2"
                          value="2"
                          [(ngModel)]="profileValues.ramConfiguration.integrityCheckOption"
                        ></p-radioButton>
                      </td>
                      <td>
                        <label class="label-clickable" for="ramConfiguration.integrityCheckOption#2" i18n>Redundancy Check</label>
                      </td>
                    </tr>
                    <tr style="vertical-align: top">
                      <td style="width: 2rem">
                        <p-radioButton
                          (onClick)="mslRadioEventHandler()"
                          name="ramConfiguration.integrityCheckOption"
                          inputId="ramConfiguration.integrityCheckOption#3"
                          value="3"
                          [(ngModel)]="profileValues.ramConfiguration.integrityCheckOption"
                        ></p-radioButton>
                      </td>
                      <td>
                        <label class="label-clickable" for="ramConfiguration.integrityCheckOption#3" i18n>Cryptographic Checksum</label>
                      </td>
                    </tr>
                    <tr style="vertical-align: top">
                      <td style="width: 2rem">
                        <p-radioButton
                          (onClick)="mslRadioEventHandler()"
                          name="ramConfiguration.integrityCheckOption"
                          inputId="ramConfiguration.integrityCheckOption#4"
                          value="4"
                          [(ngModel)]="profileValues.ramConfiguration.integrityCheckOption"
                        ></p-radioButton>
                      </td>
                      <td>
                        <label class="label-clickable" for="ramConfiguration.integrityCheckOption#4" i18n>Digital Signature</label>
                      </td>
                    </tr>
                  </table>
                </td>
                <td>
                  <table>
                    <tr style="vertical-align: top">
                      <td style="width: 2rem">
                        <p-radioButton
                          (onClick)="mslRadioEventHandler()"
                          name="ramConfiguration.cipheringOption"
                          inputId="ramConfiguration.cipheringOption#1"
                          value="1"
                          [(ngModel)]="profileValues.ramConfiguration.cipheringOption"
                        ></p-radioButton>
                      </td>
                      <td>
                        <label class="label-clickable" for="ramConfiguration.cipheringOption#1" i18n>No Ciphering</label>
                      </td>
                    </tr>
                    <tr style="vertical-align: top">
                      <td style="width: 2rem">
                        <p-radioButton
                          (onClick)="mslRadioEventHandler()"
                          name="ramConfiguration.cipheringOption"
                          inputId="ramConfiguration.cipheringOption#2"
                          value="2"
                          [(ngModel)]="profileValues.ramConfiguration.cipheringOption"
                        ></p-radioButton>
                      </td>
                      <td>
                        <label class="label-clickable" for="ramConfiguration.cipheringOption#2" i18n>Ciphering</label>
                      </td>
                    </tr>
                  </table>
                </td>
                <td>
                  <table>
                    <tr style="vertical-align: top">
                      <td style="width: 2rem">
                        <p-radioButton
                          (onClick)="mslRadioEventHandler()"
                          name="ramConfiguration.counterOption"
                          inputId="ramConfiguration.counterOption#1"
                          value="1"
                          [(ngModel)]="profileValues.ramConfiguration.counterOption"
                        ></p-radioButton>
                      </td>
                      <td>
                        <label class="label-clickable" for="ramConfiguration.counterOption#1" i18n>No counter available</label>
                      </td>
                    </tr>
                    <tr style="vertical-align: top">
                      <td style="width: 2rem">
                        <p-radioButton
                          (onClick)="mslRadioEventHandler()"
                          name="ramConfiguration.counterOption"
                          inputId="ramConfiguration.counterOption#2"
                          value="2"
                          [(ngModel)]="profileValues.ramConfiguration.counterOption"
                        ></p-radioButton>
                      </td>
                      <td>
                        <label class="label-clickable" for="ramConfiguration.counterOption#2" i18n>
                          Counter available; no replay or sequence checking
                        </label>
                      </td>
                    </tr>
                    <tr style="vertical-align: top">
                      <td style="width: 2rem">
                        <p-radioButton
                          (onClick)="mslRadioEventHandler()"
                          name="ramConfiguration.counterOption"
                          inputId="ramConfiguration.counterOption#3"
                          value="3"
                          [(ngModel)]="profileValues.ramConfiguration.counterOption"
                        ></p-radioButton>
                      </td>
                      <td>
                        <label class="label-clickable" for="ramConfiguration.counterOption#3" i18n>
                          Process if and only if counter value is higher than the value in the receiving entity
                        </label>
                      </td>
                    </tr>
                    <tr style="vertical-align: top">
                      <td style="width: 2rem">
                        <p-radioButton
                          (onClick)="mslRadioEventHandler()"
                          name="ramConfiguration.counterOption"
                          inputId="ramConfiguration.counterOption#4"
                          value="4"
                          [(ngModel)]="profileValues.ramConfiguration.counterOption"
                        ></p-radioButton>
                      </td>
                      <td>
                        <label class="label-clickable" for="ramConfiguration.counterOption#4" i18n>
                          Process if and only if counter value is one higher than the value in the receiving entity
                        </label>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </td>
    </tr>
  </table>
</div>
